import React from 'react'
import { inject, observer } from 'mobx-react'

import TicketLoader from './TicketLoader'
import Spacer from '~/components/Spacer'
import DesktopContainer from '~/components/DesktopContainer'

@inject((all) => ({
  isMobile: all.store.ui.isMobile,
  fetcherName: all.store.trafficLookup.fetcherName,
  courtFilter: all.store.trafficLookup.courtFilter,
}))
@observer
class TicketSearch extends React.Component {
  render() {
    return (
      <>
        <DesktopContainer>
          <Spacer mobile={24} desktop={40} />
          <TicketLoader fetcher={this.props.fetcherName} isBatched={!!this.props.courtFilter} />
          <Spacer mobile={40} desktop={80} />
        </DesktopContainer>
      </>
    )
  }
}

export default TicketSearch
